import React, { useState, useContext, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import s from "../styles/Dashboard.module.css";
import ProjectList from "./ProjectList";
import CreateProjectButton from "./CreateProjectButton";
import TariffDashboard from "./admin/TariffDashboard";
import PaymentConstructor from "./PaymentConstructor";
import ServiceManager from "./ServiceManager";
import AdminDashboard from "./admin/AdminDashboard";
import MobileTabsCarousel from "./MobileTabsCarousel";
import ReraitPage from "./Rerait";

const Dashboard = () => {
    const navigate = useNavigate();
    const { role, currentUser } = useContext(AuthContext);
    const [searchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState("projects");



    const tabs = [
        { key: "projects", label: "Главная", icon: "/vectors_icon/home.svg" },
        ...(role === "superadmin" ? [{ key: "superadmin", label: "Суперадмин", icon: "/vectors_icon/admin.svg" }] : []),
        ...(role === "superadmin" ? [{ key: "admin", label: "Админка", icon: "/vectors_icon/admin.svg" }] : []),
        ...(role === "superadmin" ? [{ key: "constructor", label: "Тарифы", icon: "/vectors_icon/admin.svg" }] : []),
        { key: "payments", label: "Оплата", icon: "/vectors_icon/pay_icon.svg" },
        { key: "partnersreferal", label: "Трафик", icon: "/vectors_icon/tools.svg" },
        { key: "guide", label: "Инструкция", icon: "/vectors_icon/instrukcii.svg" },
        { key: "rerait", label: "Переопубликация", icon: "/vectors_icon/instrukcii.svg" },
        ];

        const handleSelectTab = (key) => {
        setActiveTab(key);
        navigate(`?tab=${key}`);
        };

    
    useEffect(() => {
        const tab = searchParams.get("tab");
        if (tab) {
            setActiveTab(tab);
        }
    }, [searchParams]);

    const renderContent = () => {
        switch (activeTab) {
            case "projects":
                return <ProjectList/>;
            case "superadmin":
                return <ServiceManager />;
            case "admin":
                return <AdminDashboard/>;   
            case "constructor":
                return <TariffDashboard/>;
            case "templates":
                return <div>Шаблоны</div>;
            case "payments":
                return <div><PaymentConstructor/></div>;
            case "apps":
                return <div>Приложения</div>;
            case "guide":
                return <div>Инструкция</div>;
            case "rerait":
                return <ReraitPage/>;
            default:
                return <div>Выберите раздел</div>;
        }
    };

    return (
        <div className={s.dashboard_container}>
            <div className={s.sidebar}>
                <ul className={s.ul}>
                    <li className={s.li_create_project_sidebar}>
                        <div className={s.create_project_sidebar_div}>
                            <CreateProjectButton user_id={currentUser?.id} />  
                        </div>
                    </li>
                    <li className={s.li} onClick={() => {setActiveTab("projects"); navigate("?tab=projects");}}>
                        <img src="/vectors_icon/home.svg" alt="Главная" />
                        Главная
                    </li>
                    {role === "superadmin" && (
                        <li className={s.li} onClick={() =>{setActiveTab("superadmin"); navigate("?tab=superadmin");}}>
                            <img src="/vectors_icon/admin.svg" alt="Суперадмин" />
                            Суперадмин
                        </li>
                    )}
                                                            {(role === "admin" || role === "superadmin") && (
                        <li className={s.li} onClick={() =>{setActiveTab("admin"); navigate("?tab=admin");}}>
                            <img src="/vectors_icon/admin.svg" alt="админка" />
                            Админка
                        </li>
                    )}
                                        {role === "superadmin" && (
                        <li className={s.li} onClick={() =>{setActiveTab("constructor"); navigate("?tab=constructor");}}>
                            <img src="/vectors_icon/admin.svg" alt="конструктор тарифов" />
                            Тарифы
                        </li>
                    )}
                    {/* {(role === "admin" || role === "superadmin" || role === "editor") && (
                        <>
                            <li className={s.li} onClick={() => setActiveTab("admin")}>
                                <img src="/vectors_icon/admin.svg" alt="Админка" />
                                Админка
                            </li>
                            <li className={s.li} onClick={() => setActiveTab("templates")}>
                                <img src="/vectors_icon/template.svg" alt="Шаблоны" />
                                Шаблоны
                            </li>
                        </>
                    )} */}
                    <li className={s.li} onClick={() => {setActiveTab("payments"); navigate("?tab=payments");}}>
                        <img src="/vectors_icon/pay_icon.svg" alt="Оплата" />
                        Оплата
                    </li>
                    <li className={s.li} onClick={() => {setActiveTab("rerait"); navigate("?tab=rerait");}}>
                        <img src="/vectors_icon/robot.svg" alt="Переопубликация" />
                        Авто‑рерайт
                    </li>
                    <li className={s.li} onClick={() => window.open("https://pulseads.ru/bz", "_blank")}>
                        <img src="/vectors_icon/instrukcii.svg" alt="Инструкция" />
                        Инструкция
                    </li>
                </ul>
            </div>
            <div className={s.content}>
                {renderContent()}
            </div>
            {/* <div className={s.create_button}>
               <CreateProjectButton /> 
            </diwwwwwwwwwwwwwwwwqazddtgujo;
            \v> */}
            

                <MobileTabsCarousel
                    tabs={tabs}
                    activeKey={activeTab}
                    onSelect={handleSelectTab}
                    />

        </div>
    );
};

export default Dashboard;
